import upiLoadMoneyReport from '../components/upiLoadMoney/report';
import UPIQRCodeMiniHistory from '../components/upiQrCode/history';
import AccountSettings from '.././components/AccountSettings';
import moveFromPartnerReport from '../components/reports/moveFromPartnerReport';
import dmtDistributorReport from '../components/reports/dmtDistributorReport';

const distributorRoutes = [
  { path: '/upiload-money-report', component: upiLoadMoneyReport, allowedRoles: ['distributor'] },
  { path: '/upiqrmini-history', component: UPIQRCodeMiniHistory, allowedRoles: ['distributor']  },
  { path: '/move-to-partner-reports', component:moveFromPartnerReport, allowedRoles: ['distributor']},
  { path: '/dmt-distributor-report', component:dmtDistributorReport, allowedRoles: ['distributor']},
];

export  default distributorRoutes;
